import JBLflip5 from "../assets/images (2).jpeg"
export default JBLflip5; 